<template>
<v-form ref="f" lazy-validation v-model="valid">
	<v-container v-if="hotels.length">
		<v-row >
			<v-col class="pt-6 mt-1 pb-0" cols="12" sm="6" >
				<span class="headline">Проданные номера и гости</span>
			</v-col>
			<v-col class="pb-0" cols="12" sm="6" >
				<a-hotel-select v-model="hotelCode"
						  	 :hotels="hotels"
						  	 :loading="hotelLoading"
						  	 @change="getValues">
				</a-hotel-select>
			</v-col>
		</v-row>
		<v-row >
			<v-col cols="4" sm="2" class="text-center pb-0">
				<span class="subtitle-1"></span>
			</v-col>
			<v-col cols="8" sm="4" class="text-center pb-0">
				<span class="subtitle-1">Проданные номера</span>
			</v-col>
			<v-col cols="4" sm="1" class="text-center pb-0">
			</v-col>
			<v-col cols="8" sm="4" class="text-center pb-0">
				<span class="subtitle-1">Гости</span>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="pt-0" cols="4" sm="2" >
			</v-col>
			<v-col cols="4" sm="2" class="text-center">
				<span class="subtitle-1">{{ lastMonthFormat }}</span>
			</v-col>
			<v-col cols="4" sm="2" class="text-center">
				<span class="subtitle-1">{{ monthFormat }}</span>
			</v-col>
			<v-col sm="1" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
			</v-col>
			<v-col sm="2" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
				<span class="subtitle-1">{{ lastMonthFormat }}</span>
			</v-col>
			<v-col sm="2" class="text-center" v-if="$vuetify.breakpoint.smAndUp">
				<span class="subtitle-1">{{ monthFormat }}</span>
			</v-col>
		</v-row>
		<template v-for="(line, key) in form">
			<v-row v-if="line.name != 'Arrival Rooms'" :key="key">
				<v-col class="py-2" cols="4" sm="2" >
					<span class="subtitle-1">{{ line.name }}</span>
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.nights.value[0]"
								:loading="valuesLoading"
								class="my-0 py-0"
								digits=0
								readonly>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.nights.value[1]"
								:loading="valuesLoading"
								class="my-0 py-0"
								@input.native="dataChanged = true"
								digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="4" sm="1" >
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.guests.value[0]"
								:loading="valuesLoading"
								class="my-0 py-0"
								readonly
									digits=0>
					</a-number-field>
				</v-col>
				<v-col class="py-0" cols="4" sm="2" >
					<a-number-field v-model="line.guests.value[1]"
								:loading="valuesLoading"
								class="my-0 py-0"
								@input.native="dataChanged = true"
								digits=0>
					</a-number-field>
				</v-col>
			</v-row>
		</template>
		<v-row >
			<v-col class="py-6" cols="4" sm="2" >
				<span class="subtitle-1">Итого</span>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.nights[0]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.nights[1]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="1" >
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.guests[0]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="total.guests[1]"
							 readonly
							 prepend-icon="functions"
							 :loading="valuesLoading"
							 digits=0>
				</a-number-field>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="4" sm="2" class="text-center">
			</v-col>
			<v-col cols="8" sm="4" class="text-center">
				<div class="mt-6 pt-12 text-center">
					<span class="subtitle-1">Заезды</span>
				</div>
			</v-col>
		</v-row>
		<v-row>
			<v-col class="py-6" cols="4" sm="2" >
				<span class="subtitle-1">Итого</span>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="form.arrivals.arrivals.value[0]"
							 digits=0
							 :loading="valuesLoading"
							 readonly>
				</a-number-field>
			</v-col>
			<v-col class="py-0" cols="4" sm="2" >
				<a-number-field v-model="form.arrivals.arrivals.value[1]"
							 :loading="valuesLoading"
							 @input.native="dataChanged = true"
							 required
							 digits=0>
				</a-number-field>
			</v-col>
		</v-row>
		<v-row >
			<v-col class="pb-0 pt-0" cols="12" >
				<v-btn color="primary"
					   class="ml-0"
					   :disabled="!dataChanged"
					   @click="validate">
					Сохранить
				</v-btn>
			</v-col>
		</v-row>
	</v-container>
	<v-container v-else>
		<v-row>
			<v-col>
				<p class="subtitle-1">
					Нет доступных P&L отчетов
				</p>
			</v-col>
		</v-row>
	</v-container>
	<v-dialog	v-model="dialogConfirm.show"
			  	persistent
  			  	max-width="600">
		<v-card>
	  		<v-card-title class="headline">
				Подтверждение
			</v-card-title>
	        <v-card-text>

				<v-row>
					<v-col cols="12">
						<span class="text--primary" v-html="dialogConfirm.html"></span>
					</v-col>
					<v-col cols="12" class="mb-4">
						<span class="text--primary">Вы уверены, что ввели коректные данные?</span>
					</v-col>
				</v-row>
				<v-btn class="mr-2" color="primary" @click="send">
					Да
				</v-btn>
				<v-btn class="mx-2" color="secondary" @click="dialogConfirm.show = false">
					Назад
				</v-btn>
	        </v-card-text>
      	</v-card>
	</v-dialog>
</v-form>
</template>

<script>
	import _ from 'lodash'
	import aNumberField from '../../base/ANumberField.vue'
	import aHotelSelect from '../../base/AHotelSelect.vue'
	import {api} from '../../../lib/api'
	import {getMonthName, toNum, toStr} from '../../../js/common.js'

	export default {
		components: {
			aNumberField,
			aHotelSelect
		},
		data: () => ({
			valid: false,
			dataChanged: false,
			hotelCode: '',
			form: {
				direct: {
					name: 'Direct',
					nights: {
						code: 1015,
						value: ['0', '0']
					},
					guests: {
						code: 1025,
						value: ['0', '0']
					}
				},
				ota: {
					name: 'OTA',
					nights: {
						code: 1016,
						value: [0, 0]
					},
					guests: {
						code: 1026,
						value: [0, 0]
					}
				},
				ws: {
					name: 'Wholesale',
					nights: {
						code: 1017,
						value: [0, 0]
					},
					guests: {
						code: 1027,
						value: [0, 0]
					}
				},
				group: {
					name: 'Group',
					nights: {
						code: 1012,
						value: [0, 0]
					},
					guests: {
						code: 1022,
						value: [0, 0]
					}
				},
				ta: {
					name: 'Travel Agent',
					nights: {
						code: 1018,
						value: [0, 0]
					},
					guests: {
						code: 1028,
						value: [0, 0]
					}
				},
				neg: {
					name: 'Negotiated',
					nights: {
						code: 1019,
						value: [0, 0]
					},
					guests: {
						code: 1029,
						value: [0, 0]
					}
				},
				comp: {
					name: 'Complimenary',
					nights: {
						code: 1003,
						value: [0, 0]
					},
					guests: {
						code: 1023,
						value: [0, 0]
					}
				},
				hse: {
					name: 'House Use',
					nights: {
						code: 1004,
						value: [0, 0]
					},
					guests: {
						code: 1024,
						value: [0, 0]
					}
				},
				arrivals: {
					name: 'Arrival Rooms',
					arrivals: {
						code: 1050,
						value: [0, 0]
					}
				},
			},
			dc: 50,
			hotels: null,
			valuesLoading: false,
			hotelLoading: false,
			dialogConfirm: {
				show: false,
				html: ''
			}
		}),
		computed: {
			total() {
				let s = [0, 0]
				let g = [0, 0]
				for (let line in this.form) {
					if (this.form[line].nights) {
						s[0] += toNum(this.form[line].nights.value[0])
						s[1] += toNum(this.form[line].nights.value[1])
					}
					if (this.form[line].guests) {
						g[0] += toNum(this.form[line].guests.value[0])
						g[1] += toNum(this.form[line].guests.value[1])
					}
				}
				s[0] = toStr(s[0], 0)
				s[1] = toStr(s[1], 0)
				g[0] = toStr(g[0], 0)
				g[1] = toStr(g[1], 0)

				return {
					nights: s,
					guests: g
				}
			},
			selectedHotel() {
				let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(this.hotelCode)
				return this.hotels[index]
			},
			month() {
				if (this.selectedHotel && this.selectedHotel.month) return this.selectedHotel.month
				else return undefined
			},
			monthFormat() {
				if (this.month) return getMonthName(this.month.substr(5, 2), 'Ul')
				else return undefined
			},
			lastMonthFormat() {
				if (!this.month) return undefined
				let d = this.month.substr(5, 2) - 1
				if (d == 0) d = 12
				return getMonthName(d, 'Ul')
			}
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
			// this.hotelCode = 'TEST'

			this.apiFirstCall()
		},
		methods: {
			validate() {
				if (!this.$refs.f.validate()) return

				let notices = [];

				for (let line in this.form) {
					if (!this.form[line].nights) continue
					let g = toNum(this.form[line].guests.value[1])
					let n = toNum(this.form[line].nights.value[1])
					if (n == 0 && g == 0) continue
					let doubleOcc = Math.round((g / n - 1) * 100)
					if (doubleOcc < 0 || doubleOcc > 100) {
						notices.push('Коэффициент двойной загрузки по сегменту ' + this.form[line].name +
							': ' + doubleOcc + '%. Гостей: ' + g + ', продано номернов: ' + n)
					}
				}

				let a = toNum(this.form.arrivals.arrivals.value[1])
				let ts = toNum(this.total.nights[1])
				let avLos = (ts / a).toFixed(2)

				if (avLos < 1 || avLos > 20) {
					notices.push('Средняя продолжительность проживания: ' + avLos + ' дней. Заездов: ' + a + ', продано номернов: ' + this.total.nights[1])
				}

				if (notices.length) {
					this.dialogConfirm.show = true
					this.dialogConfirm.html = '<p>' + notices.join('</p><p>') + '</p>'
				}
				else {
					this.send()
				}
			},
			send() {
				this.dialogConfirm.show = false
				this.$store.dispatch('dialogLoadingStart')
				api.post('pl/set_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
					readyDept: 'rm'
				})
				.then(response => {

					this.$store.dispatch('dialogLoadingStop')
					this.$store.dispatch('dialogDone')
					this.dataChanged = false

				}, error => {})
			},
			apiFirstCall() {
				this.hotelLoading = true
				api.post('pl/get_pending_report_month', {
					hotels: this.hotels
				})
				.then(response => {
					this.hotelLoading = false

					this.hotels = response.data.hotels
					this.hotels = this.hotels.filter(hotel => !!hotel.month)
					if (this.hotels.length == 0) return
					this.hotelCode = this.$store.getters.selectedHotelCode || this.hotels[0].code
					// this.hotelCode = 'TEST'
					this.getValues()

				}, error => {})
			},
			getValues(hotelCode) {
				this.valuesLoading = true

				// console.log(hotelCode, this.hotelCode)
				//
				// if (!hotelCode) hotelCode = this.hotelCode
				// let index = this.hotels.map(hotel => (hotel.code || null)).indexOf(hotelCode)
				// let selectedHotel = this.hotels[index]
				// let month = selectedHotel.month
				//
				// console.log(month, this.selectedHotel.month)

				api.post('pl/get_hod_data', {
					form: this.trimmedForm(),
					hotelCode: this.hotelCode,
					month: this.selectedHotel.month,
					dc: this.dc,
				})
				.then(response => {
					this.valuesLoading = false

					for (let line in this.form) {
						if (this.form[line].nights) {
							this.form[line].nights.value = response.data.form[line].nights.value
						}
						if (this.form[line].guests) {
							this.form[line].guests.value = response.data.form[line].guests.value
						}
						if (this.form[line].arrivals) {
							this.form[line].arrivals.value = response.data.form[line].arrivals.value
						}
					}
					this.$refs.f.resetValidation()
					this.dataChanged = false

				}, error => {})
			},
			trimmedForm() {
				let newForm = _.cloneDeep(this.form)

				for (let line in newForm) {
					for (let prop in newForm[line]) {
						if (prop != 'nights' && prop != 'guests' && prop != 'arrivals') {
							delete newForm[line][prop]
						}
					}
				}

				return newForm
			}
		}
	}
</script>
